import { html, nothing, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { EmbeddedHost } from '../shared/embedded-host.js';
import './sdb-composition-editor.js';

@customElement('sdb-embedded-composition-editor')
class SdbEmbeddedCompositionEditor extends EmbeddedHost(LitElement) {

    render() {
        if (!this.ready) {
            return nothing;
        }

        return html`
            <sdb-composition-editor></sdb-composition-editor>
        `;
    }
}
